import React from "react";

// auth
import ConfirmMail from "../views/dashboard/auth/confirm-mail";
import LockScreen from "../views/dashboard/auth/lock-screen";
import Recoverpw from "../views/dashboard/auth/recoverpw";
import AdminLogin from "../views/dashboard/auth/adminLogin";
import SignIn from "../views/dashboard/auth/sign-in";
import SignUp from "../views/dashboard/auth/sign-up";
import SignUpInstitute from "../views/dashboard/auth/sign-up-institute";
import LoginWithOtp from "../views/dashboard/auth/login-with-otp";
import ParentSignUp from "../views/dashboard/auth/parent-sign-up";

// errors
import Error404 from "../views/dashboard/errors/error404";
import Error500 from "../views/dashboard/errors/error500";

//extrpages
import Maintenance from "../views/extrapages/maintenance";
import ComingSoon from "../views/extrapages/comingsoon";

export const SimpleRouter = [
  {
    path: "auth/confirm-mail",
    element: <ConfirmMail />,
  },
  {
    path: "auth/lock-screen",
    element: <LockScreen />,
  },
  {
    path: "auth/recoverpw",
    element: <Recoverpw />,
  },
  {
    path: "auth/sign-in",
    element: <SignIn />,
  },
  {
    path: "auth/adminpass",
    element: <AdminLogin />,
  },
  {
    path: "auth/sign-up",
    element: <SignUp />,
  },
  {
    path: "auth/institute-sign-up",
    element: <SignUpInstitute />,
  },
  {
    path: "auth/parent-sign-up",
    element: <ParentSignUp />,
  },
  {
    path: "auth/login-with-otp",
    element: <LoginWithOtp />,
  },
  {
    path: "errors/error404",
    element: <Error404 />,
  },
  {
    path: "errors/error500",
    element: <Error500 />,
  },
  {
    path: "extra-pages/pages-maintenance",
    element: <Maintenance />,
  },
  {
    path: "extra-pages/pages-comingsoon",
    element: <ComingSoon />,
  },
];
